import React from 'react';
import { View } from 'react-native';

import styles from './instruction.style';
import { useFont } from '../../hooks/lesson-player.context';
import { ThemedText } from '../themed-text';

export function Instruction({ text }) {
  const fonts = useFont();

  return (
    <View style={styles.view}>
      <ThemedText
        type="grayDark"
        style={[styles.text, { ...fonts.primary.bold }]}
        fontSize="small"
      >
        {text}
      </ThemedText>
    </View>
  );
}
